module.exports = {
      id: "liveupdate-usage",
      viewBox: "0 0 14.54 20",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#liveupdate",
      toString: function () {
        return this.url;
      }
    }